module.exports = __webpack_public_path__ + "static/media/icon-linkedin.5fbd7f44.svg";